import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { setCzasPracy } from "../../actions";
import { connect } from "react-redux";
//import Server from "../Server";

const styles = (theme) => ({
	root: {
		display: "flex"
	},
	formControl: {},
	group: {
		margin: `${theme.spacing.unit}px 0`,
		textAlign: "left"
	}
});

class RadioButtonsGroup extends React.Component {
	state = {
		value: null
	};

	//controller = new AbortController();

	handleChange = (event) => {
		//this.controller = new AbortController();
		this.setState({ value: event.target.value });
		this.props.setCzasPracy(event.target.value);
		//this.controller.abort();
		//this.controller = new AbortController();
		// this.props.store.dispatch(changeTeam(event.target.value));
		//this.props.store.dispatch(setSetvices(null, true));
		//this.getServices();
	};

	componentWillUnmount() {
		//this.controller.abort();
	}

	render() {
		const { classes, langBase, czasPracy } = this.props;

		return (
			<div className={classes.root}>
				<FormControl component="fieldset" className={classes.formControl}>
					<RadioGroup
						aria-label="Czas pracy"
						name="praca"
						className={classes.group}
						value={czasPracy}
						onChange={this.handleChange}>
						<FormControlLabel
							value={"1"}
							control={<Radio color="primary" />}
							label={langBase.il9n.$czas_0}
							labelPlacement="end"
						/>
						<FormControlLabel
							value={"2"}
							control={<Radio color="primary" />}
							label={langBase.il9n.$czas_1}
							labelPlacement="end"
						/>
						<FormControlLabel
							value={"3"}
							control={<Radio color="primary" />}
							label={langBase.il9n.$czas_2}
							labelPlacement="end"
						/>
						<FormControlLabel
							value={"4"}
							control={<Radio color="primary" />}
							label={langBase.il9n.$czas_3}
							labelPlacement="end"
						/>
						<FormControlLabel
							value={"5"}
							control={<Radio color="primary" />}
							label={langBase.il9n.$czas_4}
							labelPlacement="end"
						/>
						<FormControlLabel
							value={"6"}
							control={<Radio color="primary" />}
							label={langBase.il9n.$czas_5}
							labelPlacement="end"
						/>
					</RadioGroup>
				</FormControl>
			</div>
		);
	}
}

RadioButtonsGroup.propTypes = {
	classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	langBase: state.langBase,
	czasPracy: state.czasPracy
});

const mapDispatchToProps = {
	setCzasPracy
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RadioButtonsGroup));

//export default withStyles(styles)(RadioButtonsGroup);
